// extracted by mini-css-extract-plugin
export default {"overlay":"_u-z","bodyOpen":"av-z","content":"bv-z","header":"cv-z","close":"dv-z","closeNoHeading":"ev-z"};